import SanitizedText from 'sanitize-text/components/SanitizedText';
import { useAppSelector } from '../../reducers';
import { getFeatureWithDefaultsSelector } from '../../selectors/FeatureSelectors';
import { transformFeatureRecordWithDefaults } from '../../utils/translatedFeatureUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const removeBreaks = content => {
  const formattedSections = [];
  if (!content) {
    return formattedSections;
  }
  const sections = content.split(/<br\/>|<br \/>/);
  sections.forEach((section, index) => {
    formattedSections.push( /*#__PURE__*/_jsx(SanitizedText, {
      className: "m-all-0",
      body: section,
      formattingOptions: {
        isPlainText: false,
        shouldPreserveNewlines: true,
        shouldOpenLinksInNewTab: true
      }
    }, index));
  });
  return formattedSections;
};
const TranslatedFeature = ({
  translated,
  attribute,
  productLevel
}) => {
  const translatedDefaults = useAppSelector(state => {
    const feature = getFeatureWithDefaultsSelector(state, {
      shortName: translated.shortName.trim()
    });
    if (!feature) return null;
    return transformFeatureRecordWithDefaults({
      feature,
      productLevel
    });
  });
  const translation = translated[attribute] || translatedDefaults && translatedDefaults[attribute];
  if (translation) {
    if (attribute === 'name') return /*#__PURE__*/_jsx(_Fragment, {
      children: translation
    });
    return /*#__PURE__*/_jsx(_Fragment, {
      children: removeBreaks(translation)
    });
  }
  return null;
};
export default TranslatedFeature;